import { useState } from 'react';
import type { LibraryEntryView } from './crawlerLibrary.ts';

/**
 * The player's crawlers: a Library tab and an Archive tab. Open, make active
 * and archive from the Library; restore and delete from the Archive. Delete
 * needs a second click. All decisions about what is legal live in
 * crawlerLibrary.ts; this screen only offers them.
 */
export function LibraryView(props: {
  library: LibraryEntryView[];
  archived: LibraryEntryView[];
  activeId: string | null;
  busy: boolean;
  onOpen: (id: string) => void;
  onSetActive: (id: string) => void;
  onArchive: (id: string) => void;
  onRestore: (id: string) => void;
  onDelete: (id: string) => void;
  onCreate: () => void;
}) {
  const [tab, setTab] = useState<'library' | 'archive'>('library');
  const [confirmDelete, setConfirmDelete] = useState<string | null>(null);

  const rows = tab === 'library' ? props.library : props.archived;

  return (
    <div className="dcc-library">
      <nav className="dcc-tabs">
        <button className={tab === 'library' ? 'dcc-tab is-active' : 'dcc-tab'} onClick={() => setTab('library')}>
          Library ({props.library.length})
        </button>
        <button className={tab === 'archive' ? 'dcc-tab is-active' : 'dcc-tab'} onClick={() => setTab('archive')}>
          Archive ({props.archived.length})
        </button>
      </nav>

      {tab === 'library' && (
        <div className="dcc-creator-nav">
          <button disabled={props.busy} onClick={props.onCreate}>New crawler</button>
        </div>
      )}

      {rows.length === 0 ? (
        <p className="dcc-empty">{tab === 'library' ? 'No crawlers yet. Create one to get started, or import one below.' : 'Nothing archived.'}</p>
      ) : (
        <ul className="dcc-library-list">
          {rows.map((entry) => {
            const active = entry.id === props.activeId;
            return (
              <li key={entry.id} className={active ? 'dcc-library-row is-active' : 'dcc-library-row'}>
                <div className="dcc-library-name">
                  <strong>{entry.name}</strong>
                  {active && <span className="dcc-library-badge">Active</span>}
                  <span className="dcc-creator-meta">Level {entry.level} · Floor {entry.floor} · {entry.crawlerType}</span>
                </div>
                <div className="dcc-library-actions">
                  {tab === 'library' ? (
                    <>
                      <button disabled={props.busy} onClick={() => props.onOpen(entry.id)}>Open</button>
                      {!active && <button className="dcc-creator-secondary" disabled={props.busy} onClick={() => props.onSetActive(entry.id)}>Make active</button>}
                      <button className="dcc-creator-secondary" disabled={props.busy} onClick={() => props.onArchive(entry.id)}>Archive</button>
                    </>
                  ) : (
                    <>
                      <button className="dcc-creator-secondary" disabled={props.busy} onClick={() => props.onRestore(entry.id)}>Restore</button>
                      {confirmDelete === entry.id ? (
                        <button className="dcc-danger" disabled={props.busy} onClick={() => { setConfirmDelete(null); props.onDelete(entry.id); }}>
                          Delete forever?
                        </button>
                      ) : (
                        <button className="dcc-creator-secondary" disabled={props.busy} onClick={() => setConfirmDelete(entry.id)}>Delete</button>
                      )}
                    </>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
